<template>
    <div class="xieyi_fenlei">
        <div class="xieyi_neirong">
            <p class="biaoti-xieyi">《酷皮音乐隐私政策》</p>
            <div class="wenzi_zhenduo">
                
一、概述

<br/>欢迎使用酷皮音乐！我们非常重视您的隐私保护，本隐私政策旨在说明我们如何收集、使用、存储和保护您的个人信息。请您在使用酷皮音乐服务（以下简称 “本服务”）前仔细阅读本隐私政策。如果您不同意本隐私政策的任何部分，请不要使用本服务。
<br/>二、信息收集

<br/>1.注册信息
<br/>1.当您注册酷皮音乐账户时，我们可能会收集您的用户名、密码、电子邮箱地址、手机号码等信息，这些信息将用于创建您的账户，以便您能够登录和使用我们的服务。
<br/>2.为了方便您使用社交登录功能（如微信登录、QQ 登录等），我们可能会从第三方社交平台获取您的部分公开信息，但我们仅会在您的授权范围内使用这些信息。
<br/>2.使用信息
<br/>1.我们会收集您在使用本服务过程中的信息，包括但不限于您的搜索记录、播放历史、收藏歌曲、创建的歌单、听歌时长、听歌偏好等，这些信息将帮助我们为您提供个性化的音乐推荐和更好的服务体验。
<br/>2.我们会收集您的设备信息，例如设备型号、操作系统版本、设备标识符（如 IMEI、IDFA、Android ID 等）、设备网络信息（如 IP 地址、WiFi 信息等），以便我们优化服务的性能和兼容性，确保服务的正常运行。
<br/>3.当您使用本服务时，我们可能会收集您的位置信息（精确或大致位置），以提供基于位置的服务，例如向您推荐当地流行音乐或个性化的音乐活动，但您可以在设备设置中选择关闭位置服务，我们将尊重您的选择。
<br/>三、信息使用

<br/>1.服务提供与优化
<br/>1.我们将使用收集到的信息来为您提供音乐播放、搜索、推荐、歌单管理等服务，并根据您的偏好和使用习惯为您提供更优质的个性化体验，例如向您推荐可能感兴趣的音乐、歌手或歌单。
<br/>2.我们会使用这些信息来维护和改进本服务，包括故障排除、性能分析、用户体验优化等。
<br/>2.沟通与服务支持
<br/>1.我们可能会使用您的信息与您进行沟通，例如向您发送服务通知、账户信息更新、活动通知或客户服务信息。如果您不想接收此类信息，可以在账户设置中选择取消订阅或通知功能。
<br/>2.当您联系我们的客户服务团队时，我们可能会使用您的信息来解决您的问题和提供支持。
<br/><br/>四、信息共享

<br/>1.服务提供商
<br/>1.为了提供和维护本服务，我们可能会将您的部分信息提供给第三方服务提供商，如服务器托管商、数据存储服务商、支付处理商等。这些第三方服务提供商仅会在我们的授权范围内使用您的信息，并遵守严格的保密和安全协议。
<br/>2.我们会要求第三方服务提供商遵守相关法律法规和本隐私政策，确保您的信息安全。
<br/>2.法律要求
<br/>1.在法律法规要求或政府部门调查的情况下，我们可能会披露您的信息，例如配合执法机关进行调查、遵守法院命令或其他法律程序。
<br/>2.当我们认为披露您的信息是为了保护我们的权利、财产或安全，以及保护用户或公众的安全和利益时，我们也会进行相应的信息披露。
<br/><br/>五、信息存储

<br/>1.存储位置
<br/>1.我们会将您的信息存储在安全的服务器和数据库中，这些存储位置可能位于不同的国家或地区，我们会采取措施确保这些信息的存储符合相关法律法规。
<br/>2.存储期限
<br/>1.我们将在必要的期限内存储您的信息，以实现本服务的目的，例如为您提供个性化服务、满足法律要求或解决争议。当信息不再需要时，我们会采取合理的措施删除或匿名化处理您的信息。
<br/><br/>六、信息安全

<br/>1.我们采取合理的技术和组织措施来保护您的信息安全，防止信息的丢失、滥用、未经授权的访问、披露或篡改。
<br/>2.尽管我们采取了安全措施，但由于互联网的固有风险，我们无法保证信息的绝对安全。如果发生信息安全事件，我们会及时通知您，并采取措施降低影响。
<br/><br/>七、儿童隐私

<br/>1.酷皮音乐不针对儿童提供服务，如果我们发现我们收集了儿童的个人信息，我们将尽快删除该信息。
<br/>2.如果您是家长或监护人，并且您认为您的孩子向我们提供了个人信息，请联系我们，我们将采取相应的措施。
<br/><br/>八、您的权利

<br/>1.访问和修改
<br/>1.您有权访问和修改您在酷皮音乐账户中的个人信息，您可以通过登录您的账户在设置页面进行操作。
<br/>2.如果您发现您的信息不准确或需要更新，您可以随时进行修改。
<br/>2.删除和撤回同意
<br/>1.您可以要求我们删除您的部分或全部个人信息，但在某些情况下，我们可能需要保留部分信息以满足法律或服务要求。
<br/>2.您可以随时撤回您对我们使用您信息的同意，但这可能会影响您使用本服务的部分功能。
<br/><br/>九、第三方链接和广告

<br/>1.本服务可能包含指向第三方网站或服务的链接，这些第三方网站或服务有其独立的隐私政策，我们不对其隐私政策和信息处理行为负责。请在使用第三方服务前仔细阅读其隐私政策。
<br/>2.我们可能会展示广告，部分广告可能会收集您的信息，这些信息将由广告商根据其隐私政策处理，我们建议您查看相应广告商的隐私政策。
<br/><br/>十、隐私政策的更新

<br/>1.我们可能会根据业务发展和法律法规的要求更新本隐私政策，更新后的隐私政策将在酷皮音乐平台上公布。
<br/>2.我们会在隐私政策更新时通知您，请您定期查看本隐私政策的更新信息，继续使用本服务将被视为您接受更新后的隐私政策。
<br/><br/>十一、联系我们

<br/>如果您对本隐私政策或我们的信息处理行为有任何疑问、建议或投诉，请通过以下方式联系我们：

<br/>电子邮件：[xuna@coolpi360.com]
<br/>联系电话：[010-52668631]

            </div>
        </div>
    </div>
</template>
<script>
// 服务协议
export default {

}
</script>
<style lang="scss" scoped>
.xieyi_fenlei {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .xieyi_neirong {
        width: 1200px;
        // background-color: antiquewhite;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 30px;

        .biaoti-xieyi {
            font-size: 23px;
            font-family: YuanTi;
            font-weight: bold;
            margin-bottom: 20px;
            color: var(--them-color);
        }

        .wenzi_zhenduo {
            font-size: 16px;
            font-family: YuanTi;
            color: var(--xieyi-size);
            line-height: 33px;
            padding-bottom: 20px;
            white-space: pre-wrap;
            word-wrap: break-word;
            word-break: break-all;
        }
    }
}
</style>